import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DoneIcon from '@mui/icons-material/Done';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import TableCell from '@mui/material/TableCell';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


import { ClickAwayListener, IconButton, Switch, Tooltip } from '@mui/material';
import { useState } from 'react';


const TransformersRow = ({ row, updateForm, onDelete, handleActive }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <TableCell component="th" align="center" scope="row" style={{ maxWidth: '50px' }}>
        {row.IdCompany}
      </TableCell>
      <TableCell align="center" style={{ maxWidth: '130px' }}>{row.Company}</TableCell>
      <TableCell align="center" style={{ maxWidth: '150px' }}>
        {row.Token}

        <ClickAwayListener onClickAway={() => { setOpen(false) }}>
          <Tooltip
            PopperProps={{
              disablePortal: true,
            }}
            onClose={() => setOpen(false)}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title="Copied"
          >
            <IconButton onClick={() => {
              navigator.clipboard.writeText(row.Token)
              setOpen(!open)
            }}>
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>

        </ClickAwayListener>
      </TableCell>
      <TableCell align="center" style={{ maxWidth: '150px' }}>{row.CreateDate}</TableCell>
      <TableCell align="center">
        <Switch checked={row.Active === '1' ? true : false} onChange={(e) => { handleActive(row.IdCompany, e.target.checked) }} />
      </TableCell>
      <TableCell align="center">
        <Tooltip title="Edit">
          <IconButton onClick={() => { updateForm(row) }}>
            <ModeEditOutlineOutlinedIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Delete">
          <IconButton onClick={() => { onDelete(row.IdCompany) }}>
            <DeleteForeverOutlinedIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </>
  );
}

export default TransformersRow;